'use client';
import './index.css';

import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';

import { Text } from '@/components/atoms/Text';
import { formatDate } from '@/utils/formatDate';

import iconClockThreeSrc from '~/svg/IconClockThree.svg';
import { SvgIcon } from '@/components/SvgIcon';

export type PostByLineProps = {
  releaseDate?: string;
  timeSpentReading?: number;
  author?: {
    authorPageSlug?: string;
    image?: React.ReactNode;
    name?: string;
  };
  disableImage?: boolean;
  classNames?: {
    releaseDate?: string;
    authorName?: string;
  };
};

export default function PostByLine({
  releaseDate,
  timeSpentReading,
  author,
  classNames,
  disableImage,
}: PostByLineProps) {
  const { texts } = useTranslation();

  const AuthorDetails = () =>
    !!author?.name ? (
      <div className='flex items-center	gap-2'>
        {!disableImage && (
          <div className='h-9 w-9 rounded-full'>{author.image}</div>
        )}
        <Text
          variant='body-m'
          color='gray-500'
          classNames={{
            wrapper: cn('dark:text-gray-500', classNames?.authorName),
          }}
        >
          {author.name}
        </Text>
      </div>
    ) : null;

  return (
    <div className='flex items-start justify-between sm:items-center post-by-line-container w-full'>
      <div className='flex flex-wrap items-center gap-3'>
        <AuthorDetails />
        <div className='flex gap-4'>
          {releaseDate && (
            <Text
              variant='body-m'
              color='gray-500'
              classNames={{
                wrapper: cn('dark:text-gray-500', classNames?.releaseDate),
              }}
            >
              <span className='post-by-line_last-updated-text'>
                {texts.blog.last_updated}
              </span>{' '}
              {formatDate(new Date(releaseDate))}
            </Text>
          )}
          {!!timeSpentReading && (
            <div className='flex gap-2 text-gray-500 dark:text-gray-500'>
              <SvgIcon src={iconClockThreeSrc} />
              <Text variant='body-m' color='gray-500'>
                {timeSpentReading} {texts.blog.min_read}
              </Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
